import { render, staticRenderFns } from "./SideLeft.vue?vue&type=template&id=4ab2ae6e"
import script from "./SideLeft.vue?vue&type=script&lang=js"
export * from "./SideLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports